export default __webpack_public_path__ + "static/media/star.5cad30a2.svg";